import { computed, defineComponent, inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import ConfigsTvWishdate from "../ConfigsTvWishdate";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { configsProviderKey, type ConfigsNavigationPath } from "../../../infrastructure/configs_provider";
import { useRouter, useRoute } from "vue-router";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: { ConfigsTvWishdate },
  setup() {
    // Injections
    const { t } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const currentOrderProvider = inject(currentOrderProviderKey);
    const configsProvider = inject(configsProviderKey);

    // variables, computed, refs
    const configsPathes = computed<ConfigsNavigationPath[]>(() => {
      return configsProvider?.configsPathes.value ?? [];
    })

    const tvConfig = computed(() => {
      return currentOrderProvider?.currentOrder?.value?.configs.find(
        (c) => c.type == "TvConfig",
      ) ?? null;
    });

    // template ref zur Kind-Komponente, um vor dem Weiterschalten deren validate()/isValid abzufragen
    const wishdateRef = ref<any>(null);
    // während des Klicks auf 'next' läuft validate() ggf. noch auf einen offenen
    // Autosave-Request der Kinder; solange den Button sperren (Doppelklick-Schutz + Feedback)
    const isValidating = ref(false);

    // methods
    const next = async function(){
      const visibleChildren = [
        tvConfig.value ? wishdateRef.value : null,
      ].filter((c) => c != null);

      isValidating.value = true;
      let allValid: boolean;
      try {
        const results = await Promise.all(visibleChildren.map((c) => c.validate()));
        allValid = results.every((r) => r);
      } finally {
        isValidating.value = false;
      }
      if (!allValid) {
        return;
      }

      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const nextIdx = configsPathes.value[currentIndex + 1]
      if (nextIdx){
        router.push(nextIdx.path);
      } else {
        router.push("/customerdata");
      }
    }

    const back = function(){
      const currentIndex = configsPathes.value.findIndex((p) => p.path == route.path);
      const backIdx = configsPathes.value[currentIndex - 1]
      if (backIdx){
        router.push(backIdx.path);
      } else {
        router.push("/options");
      }
    }

    return {
      t,
      next,
      back,
      tvConfig,
      wishdateRef,
      isValidating,
    };
  },
} as any);
